// extracted by mini-css-extract-plugin
module.exports = {"below-mobile":"550px","heading":"SectionBlock-module__heading___1xV5x","content":"SectionBlock-module__content___5vFd7"};